import React from 'react';
import { ArrowRight } from 'lucide-react';
const FALLBACK = 'https://picsum.photos/800/600';
export function Services() {
  const services = [{
    title: 'Yard Cleanup & Refresh',
    description: 'Weeds pulled, gravel raked, plants trimmed, beds tidied.',
    image: 'https://cdn.magicpatterns.com/uploads/hLPT1ujMhfDHWfZRmxqoq6/sijmen-van-hooff-wVeUze_o11Y-unsplash.jpg'
  }, {
    title: 'Exterior Pressure Washing',
    description: 'Driveways, walkways, patios, and exterior walls cleaned to a like-new finish.',
    image: 'https://cdn.magicpatterns.com/uploads/8Ad8nm3y4zX8W3isNr1XC6/brian-wangenheim-uZQGEo9DGe8-unsplash.jpg'
  }, {
    title: 'Debris & Junk Removal',
    description: 'Old furniture, yard waste, and clutter hauled away same day.',
    image: 'https://cdn.magicpatterns.com/uploads/69WBRD2BHUtTPKZymnBHfW/natalie-brennan-loSTMy7gSKU-unsplash.jpg'
  }, {
    title: 'Window & Screen Cleaning',
    description: 'Streak free exterior windows so listing photos shine.',
    image: 'https://cdn.magicpatterns.com/uploads/uqhH149ycFxQvX1dhApBNM/don-stouder-cOC5IY9jwIQ-unsplash.jpg'
  }, {
    title: 'Light Landscaping',
    description: 'Mulch refresh, plant swaps, decorative rock top-offs.',
    image: 'https://cdn.magicpatterns.com/uploads/cf85tBAkyEh8AY2pJpudU7/tori-wise-RhoMTUuXF9g-unsplash.jpg'
  }, {
    title: 'Final Walkthrough Detail',
    description: 'Last minute touch ups before photos or open house.',
    image: 'https://cdn.magicpatterns.com/uploads/7edMHcmVxv33AtEZGAfQxx/vita-vilcina-KtOid0FLjqU-unsplash.jpg'
  }];
  return <section id="services" className="bg-white py-20 md:py-28" data-id="element-168">
      <div className="container mx-auto px-4 md:px-6" data-id="element-169">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-170">
          <span className="text-apex-green font-bold text-sm uppercase tracking-[0.2em] block mb-4" data-id="element-171">
            Our Services
          </span>
          <h2 className="text-apex-charcoal font-extrabold text-3xl md:text-5xl tracking-tight" data-id="element-172">
            Everything Your Listing Needs. Handled.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-173">
          {services.map((service, index) => <div key={index} className="group flex flex-col bg-white rounded-md overflow-hidden border border-gray-100 shadow-sm hover:shadow-lg transition-all hover:-translate-y-1" data-id="element-174">
              <div className="h-48 overflow-hidden bg-gray-100" data-id="element-175">
                <img src={service.image} alt={service.title} onError={e => {
              ;
              (e.currentTarget as HTMLImageElement).src = FALLBACK;
            }} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-176" />
              </div>
              <div className="p-6 flex flex-col flex-grow" data-id="element-177">
                <h3 className="text-xl font-bold text-apex-charcoal mb-2" data-id="element-178">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-6 flex-grow" data-id="element-179">
                  {service.description}
                </p>
                <a href="#contact" className="inline-flex items-center text-apex-green font-bold text-sm hover:text-green-700 transition-colors" data-id="element-180">
                  Learn more{' '}
                  <ArrowRight className="w-4 h-4 ml-1 transition-transform group-hover:translate-x-1" data-id="element-181" />
                </a>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}